import {
  useMutation,
  useQueries,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";

import { SERVICES } from "@lhd/constants";
import axios from "@lhd/libs/axios";
import { getCompanyId } from "@lhd/utility";
import {
  PayLoadUserTableColumnSettings,
  UserTableColumnSettings,
} from "@lhd/types";
import { AxiosResponse } from "axios";
import notification from "antd/lib/notification";

export const useGetUserTableColumnSettings = ({
  table_name,
}: {
  table_name: string;
}) => {
  const company_id = getCompanyId();

  return useQuery({
    queryKey: [SERVICES.USER_TABLE_COLUMN_SETTINGS, table_name, company_id],
    queryFn: async () => {
      const res = await axios.get(SERVICES.USER_TABLE_COLUMN_SETTINGS, {
        params: { table_name, company_id },
      });
      return res.data as UserTableColumnSettings;
    },
    enabled: !!table_name && !!company_id,
    refetchOnWindowFocus: false,
  });
};

export const useGetUserTableColumnSettingsList = () => {
  const company_id = getCompanyId();
  return useQuery({
    queryKey: [SERVICES.USER_TABLE_COLUMN_SETTINGS, "list"],
    queryFn: async () => {
      const res = await axios.get(
        SERVICES.USER_TABLE_COLUMN_SETTINGS + "/list",
        {
          params: { company_id },
        },
      );
      return res.data as UserTableColumnSettings[];
    },
    refetchOnWindowFocus: false,
  });
};

export const useSubmitUserTableColumnSettings = () => {
  const queryClient = useQueryClient();
  const company_id = getCompanyId();
  return useMutation(
    (payload: any) =>
      axios({
        method: "put",
        url: SERVICES.USER_TABLE_COLUMN_SETTINGS,
        data: { ...payload, company_id },
      }),
    {
      onSuccess: (
        data: AxiosResponse<UserTableColumnSettings>,
        variables: PayLoadUserTableColumnSettings,
      ) => {
        queryClient.invalidateQueries([
          SERVICES.USER_TABLE_COLUMN_SETTINGS,
          "list",
        ]);
      },
      onError: (error: any) => {
        notification.error({
          message: "データの保存に失敗しました",
          description: error.message,
        });
      },
    },
  );
};
